import React, { Fragment, useEffect, useState } from "react";
import {benefitColumn} from "Constants/TableColumns";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import {useDispatch, useSelector} from "react-redux";
import {getBenefitData} from "Stores/actions";
import RemoteTable from "Components/RemoteTable/RemoteTable";

function BenefitTable() {
    const dispatch = useDispatch();
    const { selectedProject , benefitData , benefitInfo } = useSelector((state) => ({
        selectedProject: state.project.selectedProject,
        benefitData: state.project.benefitData,
        benefitInfo: state.project.benefitInfo,
    }));
    const [loading, setLoading] = useState(false);
    const [columns, setColumns] = useState(null);

    useEffect(() => {
        (async () => {
            if (selectedProject){
                try {
                    setLoading(true);
                    const params = {
                        KeyGroup: read("groupKey"),
                        KeyUser: read("userKey"),
                        ProjectId: selectedProject.Id,
                    };
                   await dispatch(getBenefitData(params))
                    setLoading(false);
                } catch (e) {
                    setLoading(false);
                }
            }
        })();
    }, [selectedProject]);

    useEffect(() => {
        if (benefitData && benefitInfo) {
            const updateBenefitColumn = [...benefitColumn];
            updateBenefitColumn[7].hidden = !benefitInfo.IsShowPriceUser
            updateBenefitColumn[5].hidden = !benefitInfo.IsShowPriceAdmin
            updateBenefitColumn[6].hidden = !benefitInfo.IsShowPriceGroup
            updateBenefitColumn[9].hidden = !benefitInfo.IsActiveCalculator
            setColumns(updateBenefitColumn);
        }
        return () => setColumns(null);
    }, [benefitData , benefitInfo]);

    return (
        <Fragment>
            <BackDropLoading loading={loading} />
            {
                columns && (
                <RemoteTable
                    columns={columns}
                    data={benefitData}
                    title={<Translator id="profit_and_loss_list" />}
                    page={1}
                    sizePerPage={100}
                    showPagination={false}
                    totalSize={benefitData.length}
                />
            )}
        </Fragment>
    );
}

export default BenefitTable;
